import React from 'react';

// Simple animated SVG bar chart
export function BarChart({ data, color = '#2563eb', height = 90 }) {
  const max = Math.max(...data);
  const bw = 100 / data.length;
  return (
    <svg viewBox={`0 0 100 ${height}`} preserveAspectRatio="none" className="w-full" style={{ height }}>
      {data.map((v, i) => {
        const bh = (v / max) * (height - 6);
        return (
          <rect
            key={i}
            x={i * bw + bw * 0.18}
            y={height - bh}
            width={bw * 0.64}
            height={bh}
            rx={1.5}
            fill={color}
            className="grow-bar"
            style={{ animationDelay: `${i * 60}ms`, opacity: 0.55 + (v / max) * 0.45 }}
          />
        );
      })}
    </svg>
  );
}

// Simple SVG line/area chart
export function LineChart({ data, color = '#2563eb', height = 90 }) {
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const step = 100 / (data.length - 1);
  const pts = data.map((v, i) => [i * step, height - ((v - min) / range) * (height - 10) - 5]);
  const line = pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p[0]},${p[1]}`).join(' ');
  const area = `${line} L100,${height} L0,${height} Z`;
  return (
    <svg viewBox={`0 0 100 ${height}`} preserveAspectRatio="none" className="w-full" style={{ height }}>
      <defs>
        <linearGradient id={`grad-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.28" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#grad-${color.replace('#', '')})`} />
      <path d={line} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      {pts.map((p, i) => i === pts.length - 1 && (
        <circle key={i} cx={p[0]} cy={p[1]} r="2.2" fill={color} />
      ))}
    </svg>
  );
}

// Horizontal split bars
export function SplitBars({ items, color = '#4f46e5' }) {
  return (
    <div className="space-y-2.5">
      {items.map((it) => (
        <div key={it.label}>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-slate-600">{it.label}</span>
            <span className="text-slate-500">{it.pct}%</span>
          </div>
          <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
            <div className="h-full rounded-full" style={{ width: `${it.pct}%`, background: `linear-gradient(90deg, ${color}, #2563eb)` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
